// Utility function to convert code mirror selection from {line, ch} format
// to {start, end} format. This ensures consistency with other types of user input
// such as TextArea, Input etc ..
export var getCodeEditorUserInputSelection = function (codeMirrorEditor, codeMirrorData) {
    var toSelectionEndCount = 0;
    var toSelectionStartCount = 0;
    var ranges = codeMirrorData.ranges[0];
    var startLine = ranges.head.line;
    var startCh = ranges.head.ch;
    var endLine = ranges.anchor.line;
    var endCh = ranges.anchor.ch;
    codeMirrorEditor.doc.iter(0, endLine, function (line) {
        toSelectionEndCount += line.text.length + 1;
    });
    toSelectionEndCount += endCh;
    codeMirrorEditor.doc.iter(0, startLine, function (line) {
        toSelectionStartCount += line.text.length + 1;
    });
    toSelectionStartCount += startCh;
    return { start: toSelectionStartCount, end: toSelectionEndCount };
};
//# sourceMappingURL=code-editor-utils.js.map